<template>
  <div class="location_map mb-3" v-if="client.Longitude && !location.HideMapFromBookingProcess">
    <h3 class="mt-3">Location</h3>

    <p>
      <a target="_blank" :href="mapLink">{{ locationString }}</a>
    </p>

    <!--    <img :alt="client.Latitude+' '+client.Longitude" :src="map" width="100%" />-->

    <div id="map"></div>

    <!-- <code>{{client.Latitude}} {{client.Longitude}}</code> -->
  </div>
</template>

<script>
export default {
  name: "LocationMap",
  props: ["client","location"],
  data() {
    return {
      map: null
    };
  },
  mounted() {
    //var map;

    let myLatLng = { lat: this.client.Latitude, lng: this.client.Longitude };

    // eslint-disable-next-line no-undef
    this.map = new google.maps.Map(document.getElementById("map"), {
      zoom: 12,
      center: myLatLng
    });
    
    
//     var image = {
//   url: require('../assets/marker.png'),
// // eslint-disable-next-line no-undef
//   size: new google.maps.Size(40, 54),
// // eslint-disable-next-line no-undef
//   origin: new google.maps.Point(0, 0),
// // eslint-disable-next-line no-undef
//   anchor: new google.maps.Point(10, 30),
// // eslint-disable-next-line no-undef
//   scaledSize: new google.maps.Size(20, 27)
// };
    
    // var marker = new google.maps.Marker({
    //   position: myLatLng,
    //   map: this.map,
    //   title: this.client.Name,
    //   icon: image,
    // });
    // eslint-disable-next-line no-undef
    // var marker = new google.maps.Marker({
    //   position: myLatLng,
    //   map: this.map,
    //   title: "Hello World!"
    // });
  },
  computed: {
    locationString() {
      return (
        this.client.AddressLine1 +
        ", " +
        this.client.City +
        ", " +
        this.client.State +
        " " +
        this.client.PostalCode
      );
    },
    mapLink() {
      return "http://maps.google.com/maps?q=" + this.client.AddressLine1 + ",%20" + this.client.City + ",%20" + this.client.State + "%20" + this.client.PostalCode
      
      // https://www.google.com/maps/search/?api=1&query=35.7633408,-83.3264528
/*
      return (
        "https://www.google.com/maps/search/?api=1&query=" +
        this.client.Latitude +
        "," +
        this.client.Longitude
      );
*/
    }
    // mappy() {
    //   return (
    //     "https://maps.googleapis.com/maps/api/staticmap?center=" +
    //     this.client.Latitude +
    //     "," +
    //     this.client.Longitude +
    //     "&zoom=14&scale=2&size=640x400&key=AIzaSyAuvFB0_BxNfmciFksmo_ObBFryfRSROLQ"
    //   );
    // }
  }
};
</script>

<style>
#map {
  padding-bottom: 80%;
}
</style>
